import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title = "Peace of Mind Trips | Explore India with Heart",
  description = "Discover authentic travel experiences across India with Peace of Mind Trips. Explore heritage, culture, wellness, and local life with thoughtfully curated journeys.",
  canonical = "",
  ogTitle = "",
  ogDescription = "",
  ogImage = "/og-image.jpg"
}) => {
  const siteUrl = "https://pomtrips.com";
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const finalOgTitle = ogTitle || title;
  const finalOgDescription = ogDescription || description;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonical} />
      <meta property="twitter:title" content={finalOgTitle} />
      <meta property="twitter:description" content={finalOgDescription} />
      <meta property="twitter:image" content={`${siteUrl}${ogImage}`} />
    </Helmet>
  );
};
